{
  "pages": {
    "invoices": {
      "title": "Invoices"
    },
    "payments": {
      "title": "Payments"
    },
    "taxes": {
      "title": "Taxes"
    },
    "assets": {
      "title": "Fixed Assets"
    },
    "auditTrail": {
      "title": "Finance audit trail"
    },
    "accounting": {
      "title": "Accounting"
    },
    "workflowDesigner": {
      "title": "Workflow designer"
    },
    "workflows": {
      "title": "Workflows & collections"
    },
    "treasury": {
      "title": "Treasury"
    },
    "cashForecast": {
      "title": "Cash flow forecast"
    },
    "setup": {
      "title": "Finance Setup"
    },
    "revenue": {
      "title": "Revenue recognition"
    },
    "reports": {
      "title": "Financial Reports",
      "profitLoss": "Profit & Loss",
      "balanceSheet": "Balance Sheet",
      "cashFlow": "Cash Flow",
      "arAging": "AR Aging",
      "apAging": "AP Aging"
    },
    "reportBuilder": {
      "title": "Report builder"
    },
    "payables": {
      "title": "Accounts payable"
    },
    "ledger": {
      "title": "General Ledger"
    },
    "documentCapture": {
      "title": "Document capture (OCR)"
    },
    "integrations": {
      "title": "Integration health"
    },
    "expenses": {
      "title": "Expenses"
    },
    "compliance": {
      "title": "Global compliance"
    },
    "collections": {
      "title": "Collections center"
    },
    "banking": {
      "title": "Banking & Reconciliation"
    },
    "budgets": {
      "title": "Budgets & variance"
    },
    "automation": {
      "title": "Financial automation center"
    },
    "analytics": {
      "title": "Enterprise analytics"
    },
    "setupWizard": {
      "title": "Finance setup wizard"
    },
    "healthCenter": {
      "title": "Finance health center"
    },
    "closeCenter": {
      "title": "Financial close"
    },
    "businessRules": {
      "title": "Business rules"
    },
    "dashboard": {
      "title": "Finance overview",
      "description": "Cash, revenue, and business health — executive view scoped to your finance permissions",
      "noIssues": "No open issues — your books look healthy.",
      "continueSetup": "Continue setup wizard",
      "healthCenter": "Health center",
      "setupProgress": "{{completed}}/{{total}} setup steps",
      "setupIncomplete": "Finance setup is incomplete ({{progress}}).",
      "finishSetup": "Finish guided setup",
      "setupIncompleteSuffix": "to unlock go-live checks and close management.",
      "viewAllInHealthCenter": "View all in health center"
    },
    "chartOfAccountsJournalComposerMulti": "Chart of accounts, journal composer, multi-stage approval, draft → approve → post",
    "amountThresholdsApprovalRoutingAndAutomation": "Amount thresholds, approval routing, and automation triggers",
    "monthQuarterAndYearEndClose": "Month, quarter, and year-end close checklist with task owners and dependencies",
    "automaticChecksForIssuesThatAffect": "Automatic checks for issues that affect your books, cash, and compliance",
    "getYourBooksReadyInNine": "Get your books ready in nine guided steps — no accounting degree required",
    "revenueAccounts": "Revenue accounts",
    "expenseAccounts": "Expense accounts",
    "arAging": "AR aging",
    "apAging": "AP aging",
    "revenueExpensesAndAgingAnalyticsDrill": "Revenue, expenses, and aging analytics — drill-down without accounting complexity",
    "activeAssetsDepreciationMethodAndBatch": "Active assets, depreciation method, and batch depreciation run",
    "whoChangedWhatWhenWithIp": "Who changed what, when — with IP, device, and before/after snapshots",
    "noAuditEntriesYetChangesTo": "No audit entries yet. Changes to rules, documents, and compliance are tracked automatically.",
    "recurringJournalsRevenueRecognitionDunningAnd": "Recurring journals, revenue recognition, dunning, and depreciation — run manually or on schedule",
    "importStatementsAutoMatchAndManually": "Import statements, auto-match, and manually reconcile bank transactions",
    "annualAndDepartmentalBudgetsWithLive": "Annual and departmental budgets with live variance against actual GL",
    "totalOverdue": "Total overdue",
    "openReceivables": "Open receivables",
    "overdueInvoices": "Overdue invoices",
    "openPromises": "Open promises",
    "openDisputes": "Open disputes",
    "overdueReceivablesDunningPromisesToPay": "Overdue receivables, dunning, promises to pay, and dispute tracking",
    "countryTaxPacksForGstVat": "Country tax packs for GST, VAT, sales tax, and withholding",
    "financialHealth": "Financial health",
    "businessHealth": "Business health",
    "cashPosition": "Cash position",
    "revenueMtd": "Revenue (MTD)",
    "profitMtd": "Profit (MTD)",
    "pendingApprovals": "Pending approvals",
    "recommendations": "Recommendations",
    "topIssues": "Top issues",
    "expenseClaimsAndApprovalsApprovedExpenses": "Expense claims and approvals — approved expenses post to the general ledger",
    "pendingAccountingEvents": "Pending accounting events",
    "unreconciledBankTxns": "Unreconciled bank txns",
    "failedAutomations24h": "Failed automations (24h)",
    "accountingEventsApprovalsAndBankReconciliation": "Accounting events, approvals, and bank reconciliation status across connected modules",
    "createCustomerInvoicesPreviewAndEmail": "Create customer invoices, preview, and email PDF to customers",
    "trialBalanceAndAccountingEventDrill": "Trial balance and accounting event drill-down — source document → event → journal → ledger",
    "uploadVendorBillsAndReceiptsExtract": "Upload vendor bills and receipts — extract fields, review, then post",
    "openVendorPayablesAndBatchPayment": "Open vendor payables and batch payment runs",
    "customerReceiptsArAndAccountsPayable": "Customer receipts (AR) and accounts payable vendor directory",
    "saveAndRunCustomFinancialReport": "Save and run custom financial report definitions",
    "consolidationSummary": "Consolidation summary",
    "pLBalanceSheetCashFlow": "P&L, balance sheet, cash flow, AR aging — PDF and Excel export",
    "deferredRevenueSchedulesAndAsc606": "Deferred revenue schedules and ASC 606 straight-line recognition",
    "fiscalPeriodsBudgetsVarianceAndChart": "Fiscal periods, budgets, variance, and chart of accounts",
    "whatDoYouWantToDo": "What do you want to do?",
    "taxCodesTaxGroupsAndLive": "Tax codes, tax groups, and live tax calculation",
    "openingCash": "Opening cash",
    "expectedInflows": "Expected inflows",
    "expectedOutflows": "Expected outflows",
    "projectedClosing": "Projected closing",
    "expectedCashInAndOutBy": "Expected cash in and out by period — based on open receivables and payables due dates",
    "bankAccounts": "Bank accounts",
    "unreconciledTxns": "Unreconciled txns",
    "openPayables": "Open payables",
    "netLiquidity": "Net liquidity",
    "cashPositionLiquidityBankReconciliationStatus": "Cash position, liquidity, bank reconciliation status, and forecast",
    "configureMultiStageApprovalWorkflowsFor": "Configure multi-stage approval workflows for finance documents",
    "configurableApprovalWorkflowsAndArDunning": "Configurable approval workflows and AR dunning",
    "billCustomersCollectPaymentsAndManage": "Bill customers, collect payments, and manage collections — no accounting jargon required",
    "configureTaxCodesAndCalculateTax": "Configure tax codes and calculate tax on transactions",
    "payVendorsManageExpensesAndRun": "Pay vendors, manage expenses, and run payment batches — we post to the ledger for you",
    "setupCloseHealthWorkflowsAndPlatform": "Setup, close, health, workflows, and platform governance",
    "configurableFinanceWorkspace": "Configurable finance workspace with audit-safe double-entry accounting, multi-currency support, and subscription-gated enterprise capabilities.",
    "businessHealthScore": "Business health score",
    "setupProgress": "Progress: {{completed}} / {{total}} steps",
    "scheduleLabel": "Schedule: {{schedule}}",
    "manual": "Manual",
    "levelNumber": "Level {{level}}",
    "afterDaysOverdue": "After {{days}} days overdue",
    "vendorSelfService": "Vendor self-service:",
    "activeCompliancePacks": "Active: {{packs}}",
    "overallStatus": "Overall status: {{status}}",
    "oneYear": "1 year",
    "daysCount": "{{days}} days",
    "cashShortageAlert": "Cash shortage alert — projected closing cash is negative. Review payables and collections."
  },
  "links": {
    "invoiceArrow": "Invoice →",
    "configureWorkflowsArrow": "Configure workflows →",
    "openVendorPortal": "Open vendor portal",
    "accountingEventsArrow": "Accounting events →",
    "approvalsArrow": "Approvals →",
    "bankReconciliationArrow": "Bank reconciliation →",
    "backToTreasury": "← Back to treasury"
  },
  "workspaces": {
    "receivables": "Receivables",
    "tax": "Tax",
    "payables": "Payables",
    "administration": "Administration"
  },
  "breadcrumbs": {
    "finance": "Finance",
    "administration": "Administration",
    "auditTrail": "Audit trail",
    "reports": "Reports",
    "builder": "Builder",
    "rules": "Rules",
    "close": "Close",
    "documentCapture": "Document capture",
    "workflows": "Workflows",
    "designer": "Designer",
    "health": "Health",
    "setupWizard": "Setup wizard",
    "analytics": "Analytics",
    "automation": "Automation",
    "receivables": "Receivables",
    "collections": "Collections",
    "tax": "Tax",
    "compliance": "Compliance",
    "integrations": "Integrations",
    "treasury": "Treasury",
    "forecast": "Forecast",
    "ledger": "Ledger"
  },
  "headings": {
    "captureDocument": "Capture document",
    "existingWorkflows": "Existing workflows",
    "createUpdateWorkflow": "Create / update workflow",
    "approvalStages": "Approval stages",
    "savedReports": "Saved reports",
    "newReport": "New report",
    "preview": "Preview",
    "newRule": "New rule",
    "activeRules": "Active rules",
    "startNewClose": "Start a new close",
    "closeRuns": "Close runs",
    "closeChecklist": "Close checklist",
    "fiscalPeriods": "Fiscal periods",
    "budgetsForYear": "Budgets ({{fiscalYear}})",
    "budgetVsActual": "Budget vs actual",
    "chartOfAccounts": "Chart of accounts",
    "critical": "Critical",
    "warnings": "Warnings",
    "information": "Information",
    "recentRuns": "Recent runs",
    "collectionQueue": "Collection queue",
    "dunningLevels": "Dunning levels",
    "connectedModules": "Connected modules"
  },
  "tableHeaders": {
    "file": "File",
    "vendor": "Vendor",
    "invoiceNumber": "Invoice #",
    "amount": "Amount",
    "status": "Status",
    "stage": "Stage",
    "role": "Role",
    "when": "When",
    "entity": "Entity",
    "action": "Action",
    "actor": "Actor",
    "ip": "IP",
    "reason": "Reason",
    "total": "Total",
    "task": "Task",
    "ownerRole": "Owner role",
    "code": "Code",
    "start": "Start",
    "end": "End",
    "account": "Account",
    "planned": "Planned",
    "actual": "Actual",
    "variance": "Variance",
    "job": "Job",
    "started": "Started",
    "customer": "Customer",
    "daysOverdue": "Days overdue",
    "promise": "Promise",
    "period": "Period",
    "inflows": "Inflows",
    "outflows": "Outflows",
    "net": "Net",
    "cumulative": "Cumulative"
  },
  "emptyStates": {
    "noCapturedDocuments": "No captured documents. Paste bill text above to extract vendor, amount, and date automatically.",
    "noWorkflowsYet": "No workflows yet.",
    "noCustomReportsYet": "No custom reports yet.",
    "runSavedReportToPreview": "Run a saved report to preview results.",
    "noBusinessRulesConfigured": "No business rules configured yet.",
    "noCloseRunsYet": "No close runs yet.",
    "selectOrStartCloseRun": "Select or start a close run to see tasks.",
    "noPeriodsSeeded": "No periods - finance setup seeds fiscal year on first use.",
    "createBudgetForVariance": "Create a budget with account lines to see variance.",
    "noCriticalIssues": "No critical issues",
    "noWarnings": "No warnings",
    "nothingToNote": "Nothing to note",
    "noAutomationRunsYet": "No automation runs yet.",
    "noOverdueReceivables": "No overdue receivables — great job!",
    "noCompliancePackActivated": "No compliance pack activated yet. Choose a country pack below to configure tax validation."
  },
  "placeholders": {
    "documentFileName": "invoice-acme-1042.pdf"
  },
  "buttons": {
    "extracting": "Extracting...",
    "extractAndQueueForReview": "Extract & queue for review",
    "backToWorkflows": "Back to workflows",
    "remove": "Remove",
    "addStage": "Add stage",
    "saveWorkflow": "Save workflow",
    "refresh": "Refresh",
    "standardReports": "Standard reports",
    "run": "Run",
    "complete": "Complete",
    "newBudget": "New budget",
    "createQuickInvoice": "Create quick invoice",
    "recordQuickPayment": "Record quick payment",
    "addBankAccount": "Add bank account",
    "openSettings": "Open settings",
    "markStepComplete": "Mark step complete",
    "nextStep": "Next step",
    "runNow": "Run now",
    "running": "Running…",
    "activate": "Activate"
  },
  "options": {
    "documentTypes": {
      "VENDOR_BILL": "Vendor bill",
      "RECEIPT": "Receipt",
      "TAX_DOCUMENT": "Tax document",
      "BANK_STATEMENT": "Bank statement",
      "EXPENSE_RECEIPT": "Expense receipt"
    },
    "entityTypes": {
      "JOURNAL_ENTRY": "Journal entry",
      "EXPENSE": "Expense",
      "PAYMENT_RUN": "Payment run",
      "INVOICE": "Invoice"
    },
    "routingTypes": {
      "SEQUENTIAL": "Sequential",
      "PARALLEL": "Parallel"
    },
    "taxTypes": {
      "SALES": "Sales",
      "VAT": "VAT",
      "GST": "GST",
      "WITHHOLDING": "Withholding"
    },
    "baseReports": {
      "accountBalancesByType": "Account balances (by type)",
      "profitLossFiltered": "Profit & Loss (filtered)",
      "balanceSheetFiltered": "Balance Sheet (filtered)",
      "cashFlowFiltered": "Cash Flow (filtered)",
      "arAgingFiltered": "AR Aging (filtered)"
    },
    "businessRuleEntityTypes": {
      "invoice": "Invoice",
      "payment": "Payment",
      "journal": "Journal"
    },
    "closeTypes": {
      "monthEnd": "Month end",
      "quarterEnd": "Quarter end",
      "yearEnd": "Year end"
    }
  },
  "defaults": {
    "managerReview": "Manager review",
    "operatingBudgetName": "{{fiscalYear}} Operating",
    "mainBank": "Main Bank"
  },
  "dialogs": {
    "lockFiscalPeriod": {
      "title": "Lock fiscal period",
      "message": "Lock this fiscal period? New journals will be blocked for this range."
    },
    "reopenFiscalPeriod": {
      "title": "Reopen fiscal period",
      "message": "Reopen this period? Posting will be allowed again for this date range."
    },
    "newBudget": {
      "title": "New budget"
    },
    "recordPayment": {
      "title": "Record payment"
    },
    "bankAccount": {
      "title": "Bank account"
    }
  },
  "statuses": {
    "locked": "LOCKED"
  },
  "loading": "Loading...",
  "workspaceCards": {
    "receivables": {
      "guidance": "Create an invoice, send it to your customer, and record payments when they pay. We handle the accounting automatically.",
      "invoices": "Create, preview, and email customer invoices",
      "customerPayments": "Customer payments",
      "payments": "Record money received from customers",
      "collections": "Overdue AR, dunning, and promise-to-pay",
      "arAgingReport": "AR aging report",
      "arAging": "See who owes you and for how long"
    },
    "tax": {
      "taxCodes": "Tax codes",
      "taxCodesDesc": "Sales tax, VAT, GST configuration",
      "compliance": "Country tax packs and validation",
      "setupWizard": "Guided tax setup during onboarding",
      "taxReports": "Tax reports",
      "reports": "Review tax-related financial reports"
    },
    "payables": {
      "guidance": "Record vendor bills, approve expenses, and schedule payment runs. Accounting entries are created automatically when you post.",
      "apRuns": "AP & payment runs",
      "apRunsDesc": "Vendor bills, payment batches, and 3-way match",
      "documents": "OCR vendor bills and receipts before posting",
      "employeeExpenses": "Employee expenses",
      "expenses": "Submit, approve, and reimburse expenses",
      "vendorPortal": "Vendor portal",
      "portal": "Supplier self-service for POs, bills, and payments"
    },
    "admin": {
      "setupWizard": "First-time guided finance configuration",
      "health": "Issues, warnings, and one-click fixes",
      "close": "Month, quarter, and year-end close checklist",
      "automation": "Scheduled jobs and manual runs",
      "integrations": "Cross-module accounting event status",
      "audit": "Who changed what, when, and why",
      "setup": "Chart of accounts, fiscal periods, budgets",
      "approvalWorkflows": "Approval workflows",
      "workflowDesc": "Configure who approves what",
      "rules": "No-code IF/THEN approval rules",
      "usersSubscription": "Users & subscription",
      "usersSubscriptionDesc": "Module administration (platform)"
    }
  },
  "toast": {
    "journalPosted": "Journal posted",
    "accountCreated": "Account created",
    "journalDraftCreated": "Journal draft created",
    "periodLocked": "Period locked",
    "periodReopened": "Period reopened",
    "dunningSent": "Sent {{count}} dunning notices",
    "reportExported": "Exported {{reportType}} as {{format}}",
    "consolidationClosed": "Consolidation {{runNumber}} closed ({{status}})",
    "taxCreated": "Tax created",
    "stepComplete": "{{stepName}} marked complete",
    "financeLive": "Finance is live!",
    "invoiceSent": "Invoice sent to {{email}}",
    "reportSaved": "Report saved",
    "paymentRecorded": "Payment recorded",
    "ruleSaved": "Rule saved",
    "budgetCreated": "Budget created",
    "workflowSaved": "Workflow saved",
    "paymentRunCreated": "Payment run created from open payables",
    "paymentRunPosted": "Payment run posted",
    "closeRunStarted": "Close run started ({{closeType}})",
    "taskCompleted": "Task completed: {{taskName}}",
    "deferredScheduleCreated": "Deferred revenue schedule created",
    "recognizedLines": "Recognized {{count}} schedule lines",
    "depreciationComplete": "Depreciation run complete ({{count}} journals posted)",
    "importedTransactions": "Imported {{count}} transactions",
    "importedOfx": "Imported {{count}} OFX transactions",
    "importedMt940": "Imported {{count}} MT940 transactions",
    "bankFeedConfigured": "Bank feed configured",
    "autoMatched": "Auto-matched {{count}} transactions",
    "reconciliationFinalized": "Reconciliation finalized ({{status}}) for {{date}}",
    "invoiceCreated": "Invoice created"
  },
  "errors": {
    "journalApprovalOnly": "Only journal entries have workflow approval",
    "accountCodeNameRequired": "Account code and name are required",
    "journalAccountsAmount": "Select accounts and enter a positive amount",
    "postFailed": "Post failed",
    "createAccountFailed": "Create account failed",
    "createJournalFailed": "Create journal failed",
    "loadFiscalPeriods": "Failed to load fiscal periods",
    "lockPeriodFailed": "Failed to lock period",
    "reopenPeriodFailed": "Failed to reopen period",
    "createBudgetFailed": "Failed to create budget",
    "loadWorkflows": "Failed to load workflows",
    "dunningRunFailed": "Dunning run failed",
    "loadProfitLoss": "Failed to load P&L",
    "loadBalanceSheet": "Failed to load balance sheet",
    "loadCashFlow": "Failed to load cash flow",
    "loadArAging": "Failed to load AR aging",
    "exportFailed": "Export failed",
    "fiscalYearPeriodRequired": "Enter valid fiscal year and period",
    "consolidationCloseFailed": "Consolidation close failed",
    "loadTaxes": "Failed to load taxes",
    "taxCalculationFailed": "Tax calculation failed",
    "taxCodeNameRequired": "Tax code and name required",
    "createTaxFailed": "Create tax failed",
    "loadWizard": "Failed to load wizard",
    "saveProgressFailed": "Failed to save progress",
    "recipientEmailRequired": "Enter a recipient email",
    "loadInvoicePreview": "Failed to load invoice preview",
    "sendInvoiceFailed": "Failed to send invoice",
    "loadReports": "Failed to load reports",
    "saveReportFailed": "Failed to save report",
    "runReportFailed": "Failed to run report",
    "customerAmountRequired": "Select a customer and enter a valid amount",
    "recordPaymentFailed": "Failed to record payment",
    "loadRules": "Failed to load rules",
    "saveRuleFailed": "Save rule failed",
    "budgetCodeNameRequired": "Budget code and name are required",
    "createBudgetFailedShort": "Create budget failed",
    "workflowFieldsRequired": "Code, name, and at least one stage are required",
    "saveWorkflowFailed": "Failed to save workflow",
    "loadApData": "Failed to load AP data",
    "createPaymentRunFailed": "Create payment run failed",
    "loadCloseRuns": "Failed to load close runs",
    "loadTasks": "Failed to load tasks",
    "startCloseFailed": "Failed to start close",
    "completeTaskFailed": "Failed to complete task",
    "loadDeferredRevenue": "Failed to load deferred revenue",
    "validAmountRequired": "Enter a valid amount",
    "createFailed": "Create failed",
    "recognitionRunFailed": "Recognition run failed",
    "loadAssets": "Failed to load assets",
    "depreciationRunFailed": "Depreciation run failed",
    "loadBankAccounts": "Failed to load bank accounts",
    "loadUnmatched": "Failed to load unmatched transactions",
    "importFailed": "Import failed",
    "ofxImportFailed": "OFX import failed",
    "mt940ImportFailed": "MT940 import failed",
    "saveFeedConfigFailed": "Failed to save feed config",
    "autoMatchFailed": "Auto-match failed",
    "manualMatchFailed": "Manual match failed",
    "statementDateBalanceRequired": "Enter a valid statement date and balance",
    "finalizeReconciliationFailed": "Finalize reconciliation failed",
    "invoiceTotalRequired": "Invoice total must be greater than zero",
    "lineItemRequired": "Add at least one line item",
    "customerEmailRequired": "Select a customer to email the invoice",
    "createInvoiceFailed": "Failed to create invoice",
    "pdfDownloadFailed": "PDF download failed",
    "printFailed": "Print failed",
    "loadAuditTrail": "Failed to load audit trail",
    "createExpenseFailed": "Failed to create expense",
    "loadAutomation": "Failed to load automation",
    "jobRunFailed": "Job run failed",
    "loadCashForecast": "Failed to load cash forecast",
    "loadTreasury": "Failed to load treasury",
    "loadTrialBalance": "Failed to load trial balance",
    "loadCollections": "Failed to load collections",
    "loadCompliance": "Failed to load compliance",
    "activationFailed": "Activation failed",
    "loadDocuments": "Failed to load documents",
    "captureFailed": "Capture failed",
    "loadIntegrationHealth": "Failed to load integration health",
    "loadHealthCenter": "Failed to load health center",
    "loadAnalytics": "Failed to load analytics",
    "failedToLoadAccounts": "Failed to load accounts",
    "failedToLoadJournals": "Failed to load journals",
    "failedToLoadPayments": "Failed to load payments",
    "failedToLoadExpenses": "Failed to load expenses",
    "failedToLoadInvoices": "Failed to load invoices",
    "failedToLoadAccountingEvents": "Failed to load accounting events"
  },
  "dialogs": {
    "matchTransaction": "Match transaction"
  },
  "invoicePreview": "Invoice preview",
  "labels": {
    "accountCode": "Account code",
    "accountName": "Account name",
    "description": "Description",
    "ruleCode": "Rule code",
    "ruleName": "Rule name",
    "entityType": "Entity type",
    "amountThreshold": "Amount threshold",
    "approverRole": "Approver role",
    "closeType": "Close type",
    "fiscalYear": "Fiscal year",
    "period": "Period",
    "statementDate": "Statement date",
    "statementBalance": "Statement balance",
    "feedType": "Feed type",
    "feedName": "Feed name",
    "selectBankAccount": "Select bank account",
    "budgetCode": "Budget code",
    "budgetName": "Budget name",
    "customer": "Customer",
    "invoiceOptional": "Invoice # (optional)",
    "invoiceDate": "Invoice date",
    "dueDate": "Due date",
    "currency": "Currency",
    "discount": "Discount",
    "notesShownOnInvoice": "Notes (shown on invoice)",
    "selectCustomer": "Select customer",
    "autoGeneratedIfBlank": "Auto-generated if blank",
    "serviceOrProduct": "Service or product",
    "recipientEmail": "Recipient email",
    "emailMessageOptional": "Email message (optional)",
    "thankYouForYourBusiness": "Thank you for your business",
    "documentType": "Document type",
    "acmeSupplies10InvoiceInv1042": "Acme Supplies&#10;Invoice INV-1042&#10;Total: 1,250.00&#10;Date: 2026-05-15",
    "fileName": "File name",
    "pasteTextForExtractionOptional": "Paste text for extraction (optional)",
    "amount": "Amount",
    "reportCode": "Report code",
    "reportName": "Report name",
    "baseReport": "Base report",
    "includeLabelsCommaSeparatedKeywords": "Include labels (comma-separated keywords)",
    "accountTypes": "Account types",
    "revenueExpenseCash": "revenue, expense, cash",
    "sourceType": "Source type",
    "totalAmount": "Total amount",
    "taxCode": "Tax code",
    "taxName": "Tax name",
    "debitAccount": "Debit account…",
    "creditAccount": "Credit account…",
    "taxGroups": "Tax groups",
    "selectTax": "Select tax",
    "workflowCode": "Workflow code",
    "workflowName": "Workflow name",
    "routing": "Routing",
    "stageName": "Stage name",
    "paymentIdToMatch": "Payment ID to match",
    "matchAllTransactionsBeforeFinalizing": "Match all transactions before finalizing",
    "bankFeedFormatHint": "CSV: date,description,amount[,reference] · OFX/MT940 bank feed formats supported",
    "bankFeedConfiguration": "Bank feed configuration",
    "plaidConfigOnly": "Plaid (config only)"
  },
  "formActions": {
    "saveAccount": "Save account",
    "saveDraftJournal": "Save draft journal",
    "saveReport": "Save report",
    "saveRule": "Save rule",
    "lock": "Lock",
    "reopen": "Reopen",
    "importCsv": "Import CSV",
    "importOfx": "Import OFX",
    "importMt940": "Import MT940",
    "autoMatch": "Auto-match",
    "finalizing": "Finalizing…",
    "finalizeReconciliation": "Finalize reconciliation",
    "saveFeed": "Save feed"
  },
  "listActions": {
    "addTax": "Add tax",
    "createBudget": "Create budget",
    "startClose": "Start close",
    "runDunning": "Run dunning",
    "runRecognition": "Run recognition",
    "createSchedule": "Create schedule",
    "createPaymentRun": "Create payment run"
  }
}
